import dayjs from "dayjs";
import { getBestPrice } from "../../../app/api/getBestPrice";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBestPriceRequest, IBestPriceResponse, IPassengerSelection } from "../../../Orchestrator/Types/Index";
import { IGetRangeBestPriceActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/CalendarBestPrice";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";

class GetBestPriceForDateRangeAction extends BaseAction<IDefaultActionResult, IGetRangeBestPriceActionParams> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const { from, to, calendarDayInterval, type = TrainTypeEnum.outbound } = this.params!;
            const passengerTypes: IPassengerSelection[] = getRecoilStateValue("passengerTypesStateAtom") as IPassengerSelection[];
            if (from && to && calendarDayInterval) {
                let origin = from
                let destination = to
                let departureDateFrom = dayjs()
                let departureDateTo = dayjs().add(calendarDayInterval, "day")
                if (departureDateFrom.isAfter(dayjs(), 'day') || departureDateFrom.isBefore(dayjs(), 'day')) {
                    departureDateFrom = dayjs();
                }
                if (type === TrainTypeEnum.inbound) {
                    origin = to
                    destination = from
                    departureDateFrom = dayjs()
                    departureDateTo = dayjs().add(calendarDayInterval, "day")
                }
                const payload: IBestPriceRequest = {
                    departureDateFrom: departureDateFrom.format("YYYY-MM-DD"),
                    departureDateTo: departureDateTo.format("YYYY-MM-DD"),
                    originStop: {
                        stopPlaceRef: origin,
                        objectType: "StopPlaceRef"
                    },
                    destinationStop: {
                        stopPlaceRef: destination,
                        objectType: "StopPlaceRef"
                    },
                    passengers: [{age: passengerTypes?.find(p => p.id === "adults")?.minAge || 17}],    //set age fix to 12 as we need to always pass one adult
                    currency: "AED"
                }
                updateRecoilState("calendarRangeBestPriceAtom", [])
                const response: any = await getBestPrice(payload, false); // price hints are widget data - no blocking loader
                if (response.status === 'ok' && response.answer) {
                    const bestPriceResponse: IBestPriceResponse = response.answer;
                    const { prices } = bestPriceResponse
                    const sortByDateAscending = (prices || []).sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())                                       
                    updateRecoilState("calendarRangeBestPriceAtom", sortByDateAscending || [])
                    actionResult.status = "success"
                    actionResult.data = sortByDateAscending
                }
            }
        } catch (error) {
            console.error("Error in GetBestPriceForDateRangeAction:", error);
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const getBestPriceForDateRangeAction = new GetBestPriceForDateRangeAction()


